import Resource from './Resource';

export enum ChangeType {
	CONTACT_CHANGED = 'CONTACT_CHANGED',
	CLIENT_CHANGED = 'CLIENT_CHANGED',
	STAGE_CHANGED = 'STAGE_CHANGED',
	USER_CHANGED = 'USER_CHANGED',
	DATE_CHANGED = 'DATE_CHANGED',
	CUSTOM_FIELD_CHANGED = 'CUSTOM_FIELD_CHANGED',
	DESCRIPTION_CHANGED = 'DESCRIPTION_CHANGED',
	NOTES_CHANGED = 'NOTES_CHANGED',
	ORDER_ROW_CHANGED = 'ORDER_ROW_CHANGED',
	ORDER_ROW_CUSTOM_FIELD_CHANGED = 'ORDER_ROW_CUSTOM_FIELD_CHANGED',
	ORDER_ROW_ADDED = 'ORDER_ROW_ADDED',
	ORDER_ROW_DELETED = 'ORDER_ROW_DELETED',
	CAMPAIGN_CHANGED = 'CAMPAIGN_CHANGED',
	ORDER_INTERVAL_CHANGED = 'ORDER_INTERVAL_CHANGED',
	CLIENT_RELATION_CHANGED = 'CLIENT_RELATION_CHANGED',
	SALES_COACH_CHANGED = 'SALES_COACH_CHANGED',
	BUNDLE_ROW_ADDED = 'BUNDLE_ROW_ADDED',
	BUNDLE_ROW_CHANGED = 'BUNDLE_ROW_CHANGED',
	BUNDLE_ROW_DELETED = 'BUNDLE_ROW_DELETED',
	PRICELIST_CHANGED = 'PRICELIST_CHANGED',
	PROBABILITY_CHANGED = 'PROBABILITY_CHANGED'
}

export type OrderChangeLogType = {
	modBy: number;
	changes: {
		oldValue: any;
		newValue: any;
		type: ChangeType;
	}[];
	version: number;
	modDate: string;
	source?: {
		type: string;
		name?: string;
	};
};

class OrderChangeLog extends Resource {
	constructor() {
		super('orderChangeLog');
	}

	getOrderChangeLog(orderId: number, limit: number, offset: number, filters: any) {
		return this._getRequest(orderId, {
			methodName: 'find',
			params: {
				limit,
				offset,
				...(filters ?? {})
			}
		}).then(res => {
			return {
				data: res.data.data as OrderChangeLogType[],
				metadata: res.data.metadata
			};
		});
	}
}

const resource = new OrderChangeLog();

export default resource;
